import { ApiError } from '../../services/apiError';

const serverReply = (failure) => {
  if (!(failure instanceof ApiError)) {
    return failure;
  }

  if (failure.status === 0) {
    return undefined;
  }

  return failure.body || {};
};

export const describeZonesError = (failure) => {
  const error = serverReply(failure);

  if (!error) {
    return 'could not reach the server. the change was not saved.';
  }

  if (typeof error === 'string') {
    return error;
  }

  const detail = error.message ?? error.error ?? error.detail;

  if (typeof detail === 'string' && detail.trim()) {
    return detail;
  }

  return 'the server rejected the change. the change was not saved.';
};
